import { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { parseISO, format } from "date-fns";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";

const dateCellRenderer = (params) => {
  const date = format(parseISO(params.value), "dd/MM/yy HH:mm");
  return date;
};

const dateValueGetter = (params, key) => {
  if (!params.data[key]) {
    return "";
  }
  const date = format(parseISO(params.data[key]), "dd/MM/yy HH:mm");
  return date;
};

const editCellRenderer = (params) => {
  return <Link to={`/admin/users/${params.data._id}`}>Edit</Link>;
};

const deleteCellRenderer = (params) => {
  return (
    <Button onClick={() => params.data.deleteUser(params.data._id)}>
      Delete
    </Button>
  );
};

const columns = [
  {
    field: "_id",
    headerName: "_id",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "createdAt",
    headerName: "Created On",
    resizable: true,
    filter: "agTextColumnFilter",
    cellRendererFramework: dateCellRenderer,
    filterParams: {
      valueGetter: (params) => {
        return dateValueGetter(params, "createdAt");
      },
    },
  },
  {
    field: "fullName",
    headerName: "fullName",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "email",
    headerName: "email",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "edit",
    headerName: "Edit",
    resizable: true,
    filter: "agTextColumnFilter",
    cellRendererFramework: editCellRenderer,
  },
  {
    field: "delete",
    headerName: "Delete",
    resizable: true,
    filter: "agTextColumnFilter",
    cellClass: "action",
    minWidth: 120,
    cellRendererFramework: deleteCellRenderer,
  },
];

function Users() {
  const [users, setUsers] = useState([]);

  const deleteUser = async (userId) => {
    const update = { status: "deleted" };
    try {
      const response = await axios.put(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/users/${userId}`,
        update
      );
      if (response.status === 200) {
        window.location.reload(true);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const getUsers = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/users`
      );
      if (response.status === 200) {
        const users = response.data.users;
        for (const user of users) {
          user.deleteUser = deleteUser;
        }
        setUsers(users);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    getUsers(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onGridReady = (params) => {
    params.api.sizeColumnsToFit();
  };

  return (
    <div style={{ padding: "40px" }}>
      <Row>
        <Col xs={{ span: 6 }}>
          <h1 style={{ marginBottom: "30px" }}>Users</h1>
        </Col>
        <Col xs={{ span: 2, offset: 4 }}>
          <Link to={"/admin/users/new"}>
            <Button>Create new user</Button>
          </Link>
        </Col>
      </Row>
      <div
        className="ag-theme-alpine"
        style={{
          height: "500px",
          width: "100%",
        }}
      >
        <AgGridReact
          defaultColDef={{
            filter: true,
            minWidth: 170,
          }}
          floatingFilter={true}
          columnDefs={columns}
          rowData={users}
          onGridReady={onGridReady}
          rowHeight={42}
        />
      </div>
    </div>
  );
}
export default Users;
